import { render, staticRenderFns } from "./ModuleProfileEdit.vue?vue&type=template&id=49379676&scoped=true&lang=pug&"
import script from "./ModuleProfileEdit.vue?vue&type=script&lang=js&"
export * from "./ModuleProfileEdit.vue?vue&type=script&lang=js&"
import style0 from "./ModuleProfileEdit.vue?vue&type=style&index=0&id=49379676&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49379676",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VImg } from 'vuetify/lib/components/VImg';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VAvatar,VImg,VTextField,VTextarea})
